import { useState } from 'react'
import { scanInput } from '../lib/inputSecurity'

/**
 * Drop-in replacement for <input type="text"> that scans for embedded code.
 * Shows an inline error and calls onSecurityError(true/false) so the parent
 * form can block submission.
 *
 * Extra props (beyond standard input props):
 *   onSecurityError?: (hasError: boolean) => void
 *   securityErrorClassName?: string  — override error text class
 */
export function SecureInput({ onChange, onSecurityError, securityErrorClassName, className, ...props }) {
  const [secErr, setSecErr] = useState('')

  const handleChange = (e) => {
    const err = scanInput(e.target.value)
    setSecErr(err)
    onSecurityError?.(!!err)
    onChange?.(e)
  }

  return (
    <div className="w-full">
      <input
        {...props}
        onChange={handleChange}
        className={`${className || ''} ${secErr ? '!border-red-500 !bg-red-50 focus:!ring-red-400' : ''}`}
      />
      {secErr && (
        <p className={securityErrorClassName || 'text-xs text-red-600 mt-1 flex items-center gap-1'}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" className="flex-shrink-0">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
          </svg>
          {secErr}
        </p>
      )}
    </div>
  )
}

/**
 * Drop-in replacement for <textarea> that scans for embedded code.
 */
export function SecureTextarea({ onChange, onSecurityError, securityErrorClassName, className, ...props }) {
  const [secErr, setSecErr] = useState('')

  const handleChange = (e) => {
    const err = scanInput(e.target.value)
    setSecErr(err)
    onSecurityError?.(!!err)
    onChange?.(e)
  }

  return (
    <div className="w-full">
      <textarea
        {...props}
        onChange={handleChange}
        className={`${className || ''} ${secErr ? '!border-red-500 !bg-red-50 focus:!ring-red-400' : ''}`}
      />
      {secErr && (
        <p className={securityErrorClassName || 'text-xs text-red-600 mt-1 flex items-center gap-1'}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" className="flex-shrink-0">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
          </svg>
          {secErr}
        </p>
      )}
    </div>
  )
}
